import { createPortal } from 'react-dom';
import { useRef } from 'react';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import usePanelClose from './usePanelClose';
import './JernyUserButton.css';

/**
 * JernyUserPanel
 * Dropdown panel — renders via portal, anchored below the avatar button.
 * Closes on Escape or click outside.
 *
 * @param {object}   props
 * @param {boolean}  props.open         - controls visibility
 * @param {object}   props.anchorPos    - { top, right } in px — set by JernyUserButton
 * @param {string}   props.initials     - user initials for avatar in panel
 * @param {string}   props.fullName     - display name
 * @param {string}   props.email        - user email
 * @param {Function} props.onSignOut    - sign out handler
 * @param {Function} props.onClose      - close panel
 */
export default function JernyUserPanel({ open, anchorPos, initials, fullName, email, onSignOut, onClose }) {
    const panelRef = useRef(null);

    // Close on click outside and Escape — extracted to keep this component render-only
    usePanelClose(open, panelRef, onClose);

    if (!open || !anchorPos) return null;

    const panel = (
        <div
            ref={panelRef}
            className="jub-panel"
            style={{ top: anchorPos.top, right: anchorPos.right }}
        >
            {/* User info block — avatar + naam + email */}
            <div className="jub-user-info">
                <div className="jub-panel-avatar">{initials}</div>
                <div>
                    <div className="jub-user-name">{fullName}</div>
                    <div className="jub-user-email">{email}</div>
                </div>
            </div>

            <div className="jub-separator" />

            {/* Sign out action */}
            <div className="jub-menu-item jub-menu-item--signout" onClick={onSignOut}>
                <span className="jub-menu-icon">
                    <LogoutOutlinedIcon style={{ fontSize: 13 }} />
                </span>
                <span>Sign out</span>
            </div>
        </div>
    );

    return createPortal(panel, document.body);
}
